<div id="UserSettingPage" class="py-4 container-fluid" style="padding-bottom: 50px !important">
  <div *ngxPermissionsOnly="['SUPERADMIN', 'CONTROLPANELADMIN']">
    <div class="row">
      <div class="col-12">
        <h2 class="text-center">User Management</h2>
      </div>
    </div>

    <div class="d-flex justify-content-between flex-wrap-reverse mt-4">
      <div class="d-flex flex-wrap-reverse">
        <div class="dropdown mb-2" *ngxPermissionsOnly="['SUPERADMIN', 'CONTROLPANELADMIN']">
          <button type="button" dropdownToggle class="btn btn-secondary dropdown-toggle" id="dropdownmenu1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Actions <span class="caret"></span></button>
          <ul class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownmenu1">
            <li><span class="dropdown-header" *ngIf="userSelectedCount <= 0">Please select user(s)</span></li>
            <li><button *ngxPermissionsOnly="['SUPERADMIN', 'CONTROLPANELADMIN']" data-toggle="modal" [disabled]="userSelectedCount <= 0" class="dropdown-item" data-target="#toggleproductioneeraccessmodal">Enable/Disable Productioneer App Access</button></li>
            <li><button *ngxPermissionsOnly="['SUPERADMIN', 'CONTROLPANELADMIN']" data-toggle="modal" [disabled]="userSelectedCount <= 0" class="dropdown-item" data-target="#disableusersmodal">Enable/Disable Portal Access</button></li>
            <li><button *ngxPermissionsOnly="['SUPERADMIN', 'CONTROLPANELADMIN']" data-toggle="modal" [disabled]="userSelectedCount <= 0" class="dropdown-item" data-target="#addgroupmodal">Edit Group Association</button></li>
            <li><button *ngxPermissionsOnly="['SUPERADMIN', 'CONTROLPANELADMIN']" data-toggle="modal" [disabled]="userSelectedCount <= 0" class="dropdown-item" data-target="#multiplepasswordmodal">Send Reset Emails</button></li>
          </ul>
        </div>
        <span class="px-2"></span>
        <div class="mb-2">
          <button *ngIf="userSelectedCount > 0" class="btn btn-primary" title="Click to filter selected users" style="border-radius:50%;" (click)="filterSelectedUsers()">{{userSelectedCount}}</button>
        </div>
        <div class="mb-2">
          <button type="button" class="btn btn-link" title="Refresh user list" style="margin-right:15px;" [disabled]="loading" (click)="ngOnInit()">
            <ng-container *ngIf="loading; else notLoading">
              <span role="status" class="spinner-border spinner-border-sm"></span>
            </ng-container>
            <ng-template #notLoading>
              <i class="fas fa-sync-alt"></i>
            </ng-template>
          </button>
        </div>
      </div>
      <div class="mb-2">
        <button type="button" class="btn btn-success" (click)="createCloneUser('createMode','create')"><span class='fas fa-plus'></span> Create User </button>
      </div>
    </div>
    <input type="text" style="font-size: 0.9em;" [(ngModel)]="search" (keyup)="pageChanged(1)" [disabled]="loading" autocomplete="off" name="look" placeholder="Filter by Username or Full Name" class="form-control ng-pristine ng-valid ng-touch my-2 filter-input" />
    <form class="reset-form">
      <div class="table-responsive rr-elevation-z2">
        <table class="table table-hover" style="width: 100%;">
          <thead>
            <tr class="usertablerow">
              <th class="check" scope="col">
                <input type="checkbox" id="MasterCheckBox" name="MasterCheckBox" [(ngModel)]="MasterCheckBox" class="master big-checkbox" (change)="selectAllClicked()" />
                <input type="checkbox" id="MasterCheckBoxTrue" name="MasterCheckBoxTrue" checked disabled hidden [(ngModel)]="t" />
                <input type="checkbox" id="MasterCheckBoxFalse" name="MasterCheckBoxfalse" disabled hidden [(ngModel)]="f" />
              </th>
              <th class="text-left minWidth" scope="col">User <i class="fas fa-sort" (click)="orderList('username')"></i> </th>
              <th *ngxPermissionsOnly="['SUPERADMIN','CONTROLPANELADMIN']" class="text-center minWidthMD" scope="col">Portal Access</th>
              <th *ngxPermissionsOnly="['SUPERADMIN','CONTROLPANELADMIN']" class="text-center minWidthMD" scope="col">Productioneer App Access</th>
              <th colspan="2" scope="col" class="text-center" style="min-width: 310px;">
                Password Reset
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="((userProfiles | filter: search: dummbyValue)?.length == 0 && !loading); else displayUserProfiles">
              <tr>
                <td colspan="6" class="text-center"><em>No profiles found</em></td>
              </tr>
            </ng-container>
            <ng-template #displayUserProfiles>
              <tr *ngFor="let c of userProfiles | filter : search: dummbyValue | paginate: config;let i  = index" class="" scope="row">
                <td class="check"><input type="checkbox" [(ngModel)]="c.isChecked" id="{{c.username}}" name="ChildCheckBox_{{c.username}}" class="ChildCheckBox big-checkbox" (change)="userSelected(c.isChecked, c)" /></td>


                <td class="leftText minWidth" value="View/Edit Profile" (click)="createCloneUser('editMode',c)">{{c.username}} - {{c.fullname}}</td>

                <td *ngxPermissionsOnly="['SUPERADMIN','CONTROLPANELADMIN']" class="text-center">
                  <label class="switch" *ngIf="c.lockClass != 'spinner-border spinner-border-sm'">
                    <input type="checkbox" id="{{i}}_CPAccess" (click)="singleDisableUsers(c,$event,'cp',i);" [checked]="c.hasPortalAccess ? true: false">
                    <span class="slider round"></span>
                  </label>
                  <ng-container *ngIf="c.lockClass == 'spinner-border spinner-border-sm'">
                    <span id="{{i}}_spinner" role="status" class="accessSpin {{c.lockClass}}"></span>
                  </ng-container>
                </td>

                <td *ngxPermissionsOnly="['SUPERADMIN','CONTROLPANELADMIN']" class="text-center">
                  <label class="switch" *ngIf="c.lockIcon != 'spinner-border spinner-border-sm'">
                    <input type="checkbox" id="{{i}}_ProAccess" (click)="singleToggleProductioneerAccess(c,$event,'pro',i)" [checked]="c.isApproved ?  true:  false">
                    <span class="slider round"></span>
                  </label>
                  <ng-container *ngIf="c.lockIcon == 'spinner-border spinner-border-sm'">
                    <span id="{{i}}_proSpinner" role="status" class="accessSpin {{c.lockIcon}}"></span>
                  </ng-container>
                </td>
                <td>
                  <div *ngxPermissionsOnly="['CONTROLPANELADMIN']" class="text-center">
                    <button type="button" class="btn btn-sm btn-primary" *ngIf="compareUserName(c.username)" data-toggle="modal" data-target="#passwordmodal" (click)="resetUserPassword(c)">Manual Reset</button>
                  </div>
                  <div *ngxPermissionsOnly="['SUPERADMIN']" class="text-center">
                    <button type="button" class="btn btn-sm btn-primary" data-toggle="modal" data-target="#passwordmodal" (click)="resetUserPassword(c)">Manual Reset</button>
                  </div>
                </td>
                <td><button type="button" class="btn btn-sm btn-secondary" id="sendpasswordemail_{{c.username}}" (click)="sendUserResetEmail(c.email,c.username)">Send Reset Email</button> </td>
              </tr>
            </ng-template>

          </tbody>
        </table>
        <div class="text-center py-2" style="width:100%" *ngIf="loading">
          <div class="spinner-border py-1" style="width: 3rem; height: 3rem;" role="status"></div>
        </div>
        <div class="d-flex justify-content-center flex-wrap align-items-center py-2">
          <pagination-controls (pageChange)="pageChanged($event);" [id]="config.id"
                               [maxSize]="maxSize"
                               [directionLinks]="directionLinks"
                               [autoHide]="autoHide"
                               [responsive]="responsive"
                               [previousLabel]="labels.previousLabel"
                               [nextLabel]="labels.nextLabel"
                               [screenReaderPaginationLabel]="labels.screenReaderPaginationLabel"
                               [screenReaderPageLabel]="labels.screenReaderPageLabel"
                               [screenReaderCurrentLabel]="labels.screenReaderCurrentLabel">
          </pagination-controls>
          <div>
            <select class="form-control form-control-sm" name="pageLimit" id="pageLimit" [(ngModel)]="config.itemsPerPage">
              <option [selected]="p == 10" value="10">10</option>
              <option [selected]="p == 25" value="25">25</option>
              <option [selected]="p == 50" value="50">50</option>
              <option [selected]="p == 100" value="100">100</option>
            </select>
          </div>
        </div>
      </div>

    </form>

  </div>
</div>

<div class="modal fade" id="toggleproductioneeraccessmodal" tabindex="-1" role="dialog" aria-labelledby="toggleproductioneeraccessmodal" aria-hidden="true" (blur)="modalLostFocus('toggleproductioneeraccessmodal',disableUserFrm,$event)">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="toggleProductioneerAccessmodalLabel">Edit Productioneer App Access</h5>
        <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close" [disabled]="massProdSubmit" (click)="resetForm('toggleproductioneeraccessmodal',toggleProductioneerFrm)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #toggleProductioneerFrm="ngForm">
        <div class="modal-body">
          <div *ngIf="toggleProductioneerMessage" class="{{toggleProductioneerAlertClass}} | sanitize" role="alert" id="toggleProductioneerMessageBox">
            <strong>Attention!</strong> {{toggleProductioneerMessage}}
          </div>
          <div class="form-group">
            <label for="fullname" class="form-control-label">Users Selected: {{userSelectedCount}} </label>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary float-left" data-dismiss="modal" [disabled]="massProdSubmit" (click)="resetForm('toggleproductioneeraccessmodal',toggleProductioneerFrm)">Cancel</button>
          <div class="loading-indicator login-btn-container" *ngIf="!massProdSubmit">
            <button type="submit" class="btn btn-primary " [disabled]="userSelectedCount == 0" (click)="massToggleProductioneerAccess(true)">Enable Access</button>
            <button type="submit" class="btn btn-danger " [disabled]="userSelectedCount == 0" style="margin-left:10px" (click)="massToggleProductioneerAccess(false)">Disable Access</button>
          </div>
          <div class="loading-indicator login-btn-container" *ngIf="massProdSubmit">
            <button class="btn  btn-danger"><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span> Submitting...</button>
          </div>
        </div>
      </form>
    </div>
  </div>

</div>

<div class="modal fade" id="disableusersmodal" tabindex="-1" role="dialog" aria-labelledby="disableusersmodal" aria-hidden="true" (blur)="modalLostFocus('disableusersmodal',disableUserFrm,$event)">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="passwordmodallabel">Edit Portal Access</h5>
        <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close" [disabled]="massCPSubmit" (click)="resetForm('disableusersmodal',disableUserFrm)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

      <form #disableUserFrm="ngForm">
        <div class="modal-body">
          <div *ngIf="disableUserMessage" class="{{disableUserAlertClass}} | sanitize" role="alert" id="disableUserMessageBox">
            <strong>Attention!</strong> {{disableUserMessage}}
          </div>
          <div class="form-group">
            <label for="fullname" class="form-control-label">Users Selected: {{userSelectedCount}} </label>
          </div>
          

        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary float-left" data-dismiss="modal" [disabled]="massCPSubmit" (click)="resetForm('disableusersmodal',disableUserFrm)">Cancel</button>
          <div class="loading-indicator login-btn-container" *ngIf="!massCPSubmit">
            <button type="submit" class="btn btn-primary" [disabled]="userSelectedCount == 0" (click)="massDisableUsers(true)">Enable Users</button>
            <button type="submit" class="btn btn-danger" [disabled]="userSelectedCount == 0" style="margin-left:10px" (click)="massDisableUsers(false)">Disable Users</button>
          </div>
          <div class="loading-indicator login-btn-container" *ngIf="massCPSubmit">
            <button class="btn  btn-danger"><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span> Submitting...</button>
          </div>
        </div>
      </form>
    </div>
  </div>

</div>

<div class="modal fade" id="addgroupmodal" tabindex="-1" role="dialog" aria-labelledby="addgroupmodal" aria-hidden="true" (blur)="modalLostFocus('addgroupmodal',userGroupFrm,$event)">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="passwordmodallabel">Edit User Group Associations</h5>
        <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close" [disabled]="massGroupSubmit" (click)="resetForm('addgroupmodal',userGroupFrm)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #userGroupFrm="ngForm">
        <div class="modal-body">
          <div *ngIf="editGroupAssocMessage" class="{{editGroupAssocAlertClass}} | sanitize" role="alert" id="editGroupAssocMessageMessageBox">
            <strong>Attention!</strong> {{editGroupAssocMessage}}
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="fullname" class="form-control-label">Selected Users: {{userSelectedCount}}</label>
            </div>
          </div>
      
          <div class="form-row">
            <div class="form-group col-md-12">

              <label for="groups">Groups</label>
              <select name="groupselectiondropdown" id="groups" class="form-control" ngModel required>
                <option *ngFor="let groups of companyGroups" value="{{groups.groupID}}">
                  {{groups.groupName}}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary float-left" data-dismiss="modal" [disabled]="massGroupSubmit" (click)="resetForm('addgroupmodal',userGroupFrm)">Cancel</button>
          <div class="loading-indicator login-btn-container" *ngIf="!massGroupSubmit">
            <button type="submit" class="btn btn-primary" [disabled]="userGroupFrm.invalid || userSelectedCount == 0" (click)="sendUserGroups('add',userGroupFrm)">Add </button>
            <button type="submit" class="btn btn-danger" style="margin-left:10px" [disabled]="userGroupFrm.invalid || userSelectedCount == 0" (click)="sendUserGroups('delete',userGroupFrm)">Remove </button>
          </div>
          <div class="loading-indicator login-btn-container" *ngIf="massGroupSubmit">
            <button class="btn  btn-info"><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span> Submitting...</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="multiplepasswordmodal" tabindex="-1" role="dialog" aria-labelledby="multiplepasswordmodal" aria-hidden="true" (blur)="modalLostFocus('multiplepasswordmodal',multiplePasswordFrm,$event)">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="passwordmodallabel">Send Reset Emails</h5>
        <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close" [disabled]="massEmailSubmit" (click)="resetForm('multiplepasswordmodal',multiplePasswordFrm)">
          <span aria-hidden="true">&times;</span>
        </button>
        
      </div>
      <div class="modal-body">
        <div *ngIf="multiplepasswordMessage" class="{{multiplepasswordAlertClass}} | sanitize" role="alert" id="multiplePasswordMessageBox">
          <strong>Attention!</strong> {{multiplepasswordMessage}}
        </div>
        <form #multiplePasswordFrm="ngForm">
          <div class="form-group">
            <label for="fullname" class="form-control-label">Selected Users: {{userSelectedCount}}</label>
          </div>

          <div class="form-group" *ngIf="unsentEmailList">
            <table>
              <thead>
                <tr>
                  <th>Username</th>
                  <th>Email</th>
                </tr>
                <tr *ngFor="let u of unsentEmailList ">
                  <td>{{u.username}}</td>
                  <td>{{u.email}}</td>
                </tr>
              </thead>
            </table>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary float-left" data-dismiss="modal" [disabled]="massEmailSubmit" (click)="resetForm('multiplepasswordmodal',multiplePasswordFrm)">Cancel</button>
        <div class="loading-indicator login-btn-container" *ngIf="!massEmailSubmit">
          <button type="submit" class="btn btn-primary" [disabled]="userSelectedCount == 0" (click)="massPasswordEmailResest()">Send Reset Emails</button>
        </div>
        <div class="loading-indicator login-btn-container" *ngIf="massEmailSubmit">
          <button class="btn  btn-danger"><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span> Submitting...</button>
        </div>
      </div>
    </div>
  </div>

</div>




<div class="modal fade" id="createusermodal" tabindex="-1" role="dialog" aria-labelledby="createusermodal" aria-hidden="true" (blur)="modalLostFocus('createusermodal',frmAddUser,$event)">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title" id="passwordmodallabel">Create New User</h3>
        <button type="button" class="close float-right" data-dismiss="modal" aria-label="Close" (click)="resetForm('createusermodal',frmAddUser)">
          <span aria-hidden="true">&times;</span>
        </button>
        
      </div>
      <div class="modal-body">
        <div *ngIf="newUserMessage" class="{{createUserAlertClass}} | sanitize" role="alert" id="newUserMessageBox">
          <strong>Attention!</strong> {{newUserMessage}}
        </div>
        <form [formGroup]="frmAddUser" (ngSubmit)="newUserCreated()">
          <div class="form-row">
            <div class="form-group">
              <label for="fullname" class="form-control-label"> Full Name:<small class="text-danger">REQUIRED </small> </label>
              <input type="text" class="form-control" formControlName="fullname" id="fullname" name="fullname" autocomplete="off" placeholder="John Doe" required />
              <div class="alert alert-danger" role="alert" *ngIf="frmAddUser.controls['fullname'].touched &&  frmAddUser.controls['fullname'].invalid ">
                This field is required
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="fullname" class="form-control-label"> User Name: <small class="text-danger">REQUIRED </small></label>
              <input type="text" class="form-control" formControlName="username" id="username" name="username" autocomplete="off" placeholder="JohnDoe20" pattern="^[A-Za-z0-9\S]{1,255}$" required />
              <div class="alert alert-danger" role="alert" *ngIf="frmAddUser.controls['username'].touched &&  frmAddUser.controls['username'].invalid ">
                This field is required
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="email" class="form-control-label"> Email: <small class="text-danger">REQUIRED </small></label>
              <input type="text" class="form-control" formControlName="email" id="email" name="email" autocomplete="off" placeholder="example@sample.com" required />
              <div class="alert alert-danger" role="alert" *ngIf="frmAddUser.controls['email'].touched &&  frmAddUser.controls['email'].invalid ">
                This field is required
              </div>
              <div class="alert alert-danger" role="alert" *ngIf="frmAddUser.controls['email'].dirty &&  frmAddUser.controls['email'].invalid ">
                The email you have entered is not valid
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="comment" class="form-control-label">Comments:</label>
              <input type="text" class="form-control" formControlName="comment" id="comment" name="comment" autocomplete="off" placeholder="Great Employee" />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="password" class="form-control-label">Password:</label>
              <input type="text" class="form-control" formControlName="password" id="password" name="password" autocomplete="off" placeholder="password1 - leave empty for default" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" />
            </div>
          </div>
          <div class="modal-footer">

            <button type="button" class="btn btn-secondary float-left" data-dismiss="modal" (click)="resetForm('createusermodal',frmAddUser)">Close</button>
            <div class="loading-indicator login-btn-container" *ngIf="!submitted">
              <button type="submit" class="btn btn-primary" [disabled]="frmAddUser.invalid || checkForm() || frmAddUser.pristine">Create User</button>
            </div>
            <div class="loading-indicator login-btn-container" *ngIf="submitted">
              <button class="btn  btn-danger"><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate"></span> Submitting...</button>
            </div>
          </div>

        </form>
      </div>

    </div>
  </div>

</div>

<div class="modal fade" id="passwordmodal" tabindex="-1" role="dialog" aria-labelledby="passwordmodal" aria-hidden="true" (blur)="modalLostFocus('passwordmodal',null,$event)">
  <manual-password-reset [UserPasswordReset]="returnUser()"></manual-password-reset>
</div>
